// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2DkVN","topBottomGutter":"Layout_topBottomGutter__1nEO3"};